<template>
    <div class="c-sort">
        <div class="c-sort__title">Сортировать по:</div>
        <div class="catalog-select">
            <select class="catalog-select__select" @change="setSort" v-model="elementsSort">
                <option value="0">Популярности</option>
                <option value="1">Дешевле</option>
                <option value="2">Дороже</option>
            </select>
        </div>
    </div>
</template>

<script>
export default {
    name   : "CatalogSort",
    props  : {
        sort: Number,
    },
    data() {
        return {
            elementsSort: -1,
        }
    },
    methods: {
        setSort() {
            this.elementsSort = this.elementsSort ? this.elementsSort : -1;
            fetch('/api/catalog/settings/sort/', {
                method: 'POST',
                body  : JSON.stringify({'sort': this.elementsSort})
            })
                .then(response => response.json())
                .then(result => {
                    if(!result.success)
                        window.toast.error(result.message);
                    else
                        location.reload();
                })
        },
    },
    created() {
        this.elementsSort = this.sort;
    }
}
</script>

<style scoped>

</style>